import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconNavigationArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.49935 2.66675L7.55935 3.60675L11.2793 7.33341H3.16602V8.66675H11.2793L7.55935 12.3934L8.49935 13.3334L13.8327 8.00008L8.49935 2.66675Z",
		fill: "#959595"
	})
});
export default SvgIconNavigationArrowRight;
